/**
 * Leaving the portal for a provider page (Stripe onboarding). One object
 * so tests can replace `go` instead of jsdom's non-configurable
 * window.location.assign.
 */
export const externalNav = {
  go(url: string): void {
    window.location.assign(url);
  },
};
